import styled from 'styled-components';
import { Button, ModalBody, Typography } from '@web-chat-core/ui-kit';

export const DeepDialog = styled(ModalBody)`
    width: 370px;
    padding: 24px;
    overflow: inherit;
    z-index: 1;
    border-radius: 24px;
    align-items: center;
    text-align: center;
`;

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const DialogButton = styled(Button)``;

export const AppText = styled(Typography)`
    margin: 16px 0 8px 0;
`;

export const AppIconWrapper = styled.img`
    height: 73px;
    width: auto;
`;

export const DialogWrapper = styled.div<{ background: string }>`
    height: 100%;
    width: 100%;
    background: url(${props => props.background}) repeat center center;
`;

export const DialogHeader = styled.header`
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    padding: 5px;
    box-sizing: border-box;
`;
